module.exports = __webpack_public_path__ + "static/media/webfont.97ae28fb.eot";